export default __webpack_public_path__ + "slices/main/assets/public/media/news-card-3@2x.67ed3cf22d651a9eb9aca4b2681feba4.png";